import axios from './axios';

const config = {
  axios,
  api: {
    host: process.env.API_URL,
  },
  wsHost:       process.env.WS_URL,
  stripePK:     process.env.STRIPE_PK,
  devTools:     true,
  imagesBucket: {
    web:    process.env.IMAGES_URL,
    kiosk:  process.env.IMAGES_URL,
    mobile: process.env.IMAGES_URL,
  },
  googleMapApiKey:    process.env.GOOGLEMAP_API_KEY,
  merchantIdentifier: process.env.MERCHANT_IDENTIFIER,
};

/**
 * Configuration object for the application
 * @property {Object} api - configuration for API domain/prefix
 * @property {string} api.host - API domain with prefix uri
 */
Object.assign(config.axios, { baseURL: config.api.host });

/**
 * @summary Returns the configuration parameter.
 *
 * @author Dmitry Semenov
 *
 * @param {str} key - config's key
 */
function getItem(key) {
  return key in config ? config[key] : null;
}

/**
 * @summary Sets the configuration parameter.
 *
 * @author Dmitry Semenov
 *
 * @param {str} key - config's key
 * @param {str|number|boolean} value - config's key value
 */
function setItem(key, value) {
  config[key] = value;
}

Object.assign(config, {
  getItem,
  setItem,
});

export default config;



// WEBPACK FOOTER //
// ./src/config/index.js